import JobLayout from "./JobLayout.tsx";
import {JobsPostings} from "../jobs.ts";
import {imageMap} from "../../../images/imageMap.ts";

export default function JobSalesConsultant20250528() {
    return <JobLayout job={JobsPostings.SalesConsultant20250528}>
        <p>
            Er du klar til en hverdag med højt tempo, gode kollegaer, masser af grin, interne konkurrencer og en stærk teamånd?
            Hos Hiper leder vi efter nye kollegaer til vores salgsteam &ndash; og måske er det netop dig!
        </p>
        <p>
            <img src={imageMap.jobs.sales_person} alt={'Et billede af Hipers medarbejder.'}/>
        </p>

        <h2 className={'heading heading--montserrat heading--left heading--small'}>
            Om jobbet
        </h2>
        <p>
            Som salgskonsulent i Hiper bliver du en del af en dynamisk salgsafdeling &ndash; midt i et callcenter, der bl.a. også rummer kundeservice, teknisk support og back office.
            Vi arbejder tæt sammen, deler viden og har det sjovt imens.
            Du bliver en vigtig brik i vores bestræbelser på at forblive Danmarks bedste internetudbyder.
            Vi brænder for at rådgive og sælge det bedste internet til vores kunder;
            om det så er til gameren, streameren eller dem, som bare elsker at surfe &ndash; så har vi den rigtige løsning.
            Din primære opgave vil bestå i, med salg for øje, at modtage opkald og kontakte potentielle kunder, som selv har vist interesse for køb af internet.
            Desuden, vil du arbejde med at sikre fastholdelse af Hipers kundebase gennem en række fastholdelsesopgaver.
        </p>
        <p>
            Som vores nye salgskonsulent skal du være med til at udbygge vores kundekreds, slå rekorder og nå vores løbende målsætninger.
        </p>

        <h2 className={'heading heading--montserrat heading--left heading--small'}>
            I løbet af en arbejdsdag i Hipers salgsafdeling, vil du bl.a. have mulighed for at:
        </h2>
        <ul className={'list list--bullet'}>
            <li>Tage imod indgående henvendelser og oprette nye kunder via telefon, mail og chat.</li>
            <li>Kontakte potentielle kunder, som har vist interesse for internet, med salg for øje.</li>
            <li>Rådgive og fastholde kunder, der ønsker at opsige.</li>
            <li>Deltage på diverse briefs og møder med henblik på status, performance og sparring.</li>
            <li>Arbejde tæt samarbejde med de øvrige afdelinger i huset.</li>
        </ul>

        <h2 className={'heading heading--montserrat heading--left heading--small'}>
            Om dig
        </h2>
        <p>
            Vi leder ikke efter et perfekt CV &ndash; vi leder efter den rette personlighed.
            For at få succes i stillingen, er det en fordel at du er stærk kommunikativt og har lyst til at lære.
            Du skal trives i en arbejdsdag, hvor størstedelen af din arbejdstid foregår i dialog med kunder via telefon, mails og chat.
            Det er en fordel, hvis du har erfaring i en lignende rolle med salg og fastholdelse af kunder, men det vigtigste er at du har lyst til at lære.
            Derudover ser vi meget gerne, at du:
        </p>
        <ul className={'list list--bullet'}>
            <li>Er nysgerrig, proaktiv og har en overbevisende adfærd.</li>
            <li>Har fokus på at levere resultater.</li>
            <li>Er udadvendt, har ”smil” i stemmen og er god til at tale med alle typer mennesker.</li>
            <li>Hurtigt kan omstille dig i forhold til skift mellem teamets opgaver.</li>
            <li>Har fokus på effektivitet og fungerer godt i et højt tempo.</li>
            <li>Bidrager til et positivt samarbejde med dine kolleger.</li>
            <li>Er nysgerrig og klar på at lære &ndash; resten skal vi nok lære dig.</li>
        </ul>

        <h2 className={'heading heading--montserrat heading--left heading--small'}>
            Det får du hos os:
        </h2>
        <ul className={'list list--bullet'}>
            <li>Grundig oplæring og løbende udvikling &ndash; erfaring er ikke et krav.</li>
            <li>En konkurrencedygtig løn bestående af en garantiløn samt provision uden loft.</li>
            <li>Gratis medarbejder-internet fra Hiper.</li>
            <li>Gode organiske leads med interesse for internet.</li>
            <li>Et ungt, dynamisk team med dedikerede og hjælpsomme kollegaer, som altid vil hjælpe.</li>
            <li>Hiper-fit træninger med valgfri deltagelse 3 gange om ugen med personlige trænere fra Pro Sundhed.</li>
            <li>Frokostordning, frugt, snacks og selvfølgelig god kaffe.</li>
            <li>Hyggelige fredagsbarer, sociale arrangementer og firmafester (både i Hiper og Nuuday).</li>
            <li>Pensionsordning via PFA og adgang til Nuudays medarbejderfordele.</li>
            <li>Højt til loftet, dårlig humor og god musik - desuden har vi et stærkt socialt sammenhold, som vi vægter højt, og håber du vil være en del af.</li>
        </ul>
        <p>
            <strong>PS:</strong>{' '}
            Hiper har vundet prisen for &ldquo;Mest værdi for pengene&rdquo; hele 6 år i træk og har desuden 4,7 ud af 5 stjerner på Trustpilot!
            Det er vi stolte af &ndash; og du kan være med til at fortsætte den rejse.
        </p>

        <h2 className={'heading heading--montserrat heading--left heading--small'}>
            Her holder vi til
        </h2>
        <p>
            Lige nu sidder vi på Adelgade 15, men snart flytter vi til Teglholmsgade 1 i København SV &ndash; ind i Nuudays hovedkontor.
        </p>

        <h2 className={'heading heading--montserrat heading--left heading--small'}>
            Interesseret?
        </h2>
        <p>
            Så tøv ikke &ndash; vi glæder os til at høre fra dig!
        </p>
        <p>
            Du sender CV og ansøgning til Markus Fryd, Salgschef i Hiper, på: <a href={'mailto:mfr@hiper.dk'}>mfr@hiper.dk</a>.
            Har du spørgsmål til stillingen, kan du ringe til Markus Fryd på <a href={'tel:+4528407872'}>28 40 78 72</a>.
        </p>
    </JobLayout>
}
